export default __webpack_public_path__ + "static/media/8.d77e9cfe.jpg";